import axiosPost from "./axiosPost";

export const SFHabitacionGet = async (credentials, data) => {
    const body = {
        service: "SFHabitacionGet",
        params: {
            SFHotelId: data?.SFHotelId ?? null,
            SFHabitacionId: data?.SFHabitacionId ?? null,
            SFHabitacionStatus: data?.SFHabitacionStatus || null,
            SFHabitacionGenero: data?.SFHabitacionGenero || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if (result?.status?.code === 0) {
        return [result.status];
    }
    return result.result;
};
